import { render } from "./SelectLogo.vue?vue&type=template&id=e4bef32e&scoped=true"
import script from "./SelectLogo.vue?vue&type=script&lang=js"
export * from "./SelectLogo.vue?vue&type=script&lang=js"

import "./SelectLogo.vue?vue&type=style&index=0&id=e4bef32e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4bef32e"]])

export default __exports__